import React from 'react';
import {
  Button,
  Chip,
} from '@mui/material';
import moment from 'moment';

import {
  AccountTable,
  DashboardError,
  DashboardPage,
  IAccountTableColumn,
  JobPublicationDetails,
} from '../../components/JobsAccount';
import { CPGJOBS_SITE_URL } from '../../components/CpgChrome/cpgSites';
import { useGetMyApplicationsQuery } from '../../services/serviceJobsAccount';
import { IMyJobApplication } from '../../services/serviceJobsAccount/interfaces';

const monoControlStyles = {
  fontWeight: 700,
} as const;

const jobTitleStyles = {
  fontFamily: 'var(--font-sans)',
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: 1.5,
} as const;

const formatDate = (date: string | null): string => (
  date ? moment(date).format('MM/DD/YYYY') : '—'
);

export const MyApplications = () => {
  const { data, error, isLoading, isFetching } = useGetMyApplicationsQuery();
  const applications = data || [];

  const columns: IAccountTableColumn<IMyJobApplication>[] = [
    {
      id: 'job',
      label: 'Job',
      render: (application) => (
        <JobPublicationDetails
          title={application.jobTitle || 'Job listing'}
          path={application.slug}
          siteId={application.siteId}
          isActive={application.isActive}
          titleSx={jobTitleStyles}
        />
      ),
    },
    {
      id: 'company',
      label: 'Company',
      render: (application) => application.company || '—',
    },
    {
      id: 'dateApplied',
      label: 'Date Applied',
      width: 140,
      render: (application) => formatDate(application.dateApplied),
    },
    {
      id: 'status',
      label: 'Status',
      width: 180,
      render: (application) => (
        <Chip
          size="small"
          color={application.viewed ? 'success' : 'default'}
          label={application.viewed ? 'Viewed by employer' : 'Submitted'}
          sx={{
            ...monoControlStyles,
            fontSize: '0.68rem',
          }}
        />
      ),
    },
  ];

  return (
    <DashboardPage
      title="My Applications"
      actions={(
        <Button
          component="a"
          href={`${CPGJOBS_SITE_URL}/jobs`}
          variant="contained"
          sx={{
            ...monoControlStyles,
            fontSize: '0.78rem',
          }}
        >
          Browse Jobs
        </Button>
      )}
    >
      <DashboardError
        error={error}
        fallback="We could not load your job applications. Please try again."
      />
      <AccountTable
        ariaLabel="My job applications"
        columns={columns}
        rows={applications}
        getRowId={(application) => application.applicationId}
        emptyMessage="You have not submitted any applications through CPG Jobs yet."
        isLoading={isLoading || isFetching}
      />
    </DashboardPage>
  );
};

export default MyApplications;
